// departments.queryKeys.ts
export const DEPARTMENT_KEYS = {
    base: 'departments',
    all: ['departments'],
    list: ['departments', 'list'],
    detail: (id: string) => ['departments', 'detail', id],
    byCompany: (companyId: string) => ['departments', 'company', companyId]
} as const;
